export const initialDocument = {
  description_en: '',
  description_no: '',
  name_en: '',
  name_no: '',
  is_required: false,
};
